import isEmpty from "lodash/isEmpty"
import filter from "lodash/filter"
import map from "lodash/map"
import find from "lodash/find"
import get from "lodash/get"
// * component-lib * //
import { Component } from "react"
import PropTypes from "prop-types"
import { ReactSVG } from "react-svg"
import Typography from "component-lib/Base/components/Typography"
import getLanguageRoute from "utils-lib/getLanguageRoute"
import getContentUrl from "utils-lib/getContentUrl"

import { withAuthentication } from "hoc-lib/appAuthentication"
import { withLocalization } from "hoc-lib/localization"
import { feUrls } from "utils-lib/builds"
import { getWindow } from "utils-lib/getWindow"
import withRouter from "hoc-lib/router"
import "./MobileNavItems.scss"
import { isTeamsitePage } from "utils-lib/isTeamsitePage"
import { isMyWMApp } from "utils-lib/isMyWMApp"
import TextInput from "component-lib/Base/components/TextInput"
import { KEY_CODE_MAPPING } from "constants-lib/keyCodes"
import {
  Link,
  Button,
  ButtonPrimary,
  ButtonTextIcon,
  ButtonArrow,
} from "../../../../../Base"
import MegaNavSection from "../../../MegaNav/components/MegaNavSection"
import MenuItem from "../../../BottomHeader/components/MenuItem/MenuItem"
import LanguageDropdown from "../../../TopHeader/components/LanguageDropdown/LanguageDropdownContainer"
import FooterLegal from "../../../../../Footer/components/FooterLegal/FooterLegal"

const ssrWindow = getWindow()

const languages = [
  {
    label: `US - English`,
    code: `en_US`,
    url: `/content/dam/wm/icons/us-flag-icon-small.svg`,
    altText: `USA`,
  },
  {
    label: `CA - English`,
    code: `en_CA`,
    url: `/content/dam/wm/icons/ca-flag-icon-small.svg`,
    altText: `Canada`,
  },
  {
    label: `CA - French`,
    code: `fr_CA`,
    url: `/content/dam/wm/icons/ca-flag-icon-small.svg`,
    altText: `Canada`,
  },
]

const menuItems = {
  PAY_MY_BILL: `paymybill`,
  CART: `cart`,
  DROP_OFF_LOCATIONS: `dropofflocations`,
  MY_WM: `mywm`,
  ALERTS: `alerts`,
}

const strings = {
  en_CA: {
    VIEW_MY_DASHBOARD: `VIEW MY DASHBOARD`,
    CREATE_YOUR_ONLINE_PROFILE: `Create Online Profile`,
    LOG_IN: `Log in`,
    LOG_OUT: `Log out`,
    WELCOME: `WELCOME`,
    HAVE_A_BILLING_ACCOUNT: `Have a billing account?`,
    LINK_ACCOUNT: `Link Account`,
    DONT_HAVE_AN_ACCOUNT: `Don't have an account?`,
    SIGN_UP: `Sign Up`,
    BACK: `Back`,
    SEARCH_ZENDESK: `Search`,
    MY_WM: `My WM`,
  },

  fr_CA: {
    VIEW_MY_DASHBOARD: `VOIR MON TABLEAU DE BORD`,
    CREATE_YOUR_ONLINE_PROFILE: `Créez profil en ligne`,
    LOG_IN: ` Connexion`,
    LOG_OUT: `Fermer la session`,
    WELCOME: `BIENVENUE`,
    HAVE_A_BILLING_ACCOUNT: `Vous avez un compte de facturation ? `,
    LINK_ACCOUNT: `Lier le compte`,
    DONT_HAVE_AN_ACCOUNT: `Avez-vous un compte ? `,
    SIGN_UP: `S'inscrire`,
    BACK: `RETOUR`,
    SEARCH_ZENDESK: `Rechercher`,
    MY_WM: `Mon WM`,
  },
}

class MobileNavItems extends Component {
  constructor(props) {
    super(props)
    this.state = {
      megaNavSubviewSelection: ``,
      showUserScreen: false,
    }
  }

  handleBackButton = (event) => {
    event.preventDefault()
    this.setState({ showUserScreen: false })
  }

  handleUserIcon = (event) => {
    event.preventDefault()
    if (this.state.showUserScreen) {
      this.setState({ showUserScreen: false })
    } else {
      this.setState({ showUserScreen: true })
    }
  }

  navigateToZendesk = () => {
    const query = this.state.searchText
    if (query) {
      ssrWindow.location = `https://support.wm.com/hc/en-us/search?utf8=%E2%9C%93&query=${query}`
    }
  }

  renderMegaNavSection(links, shouldShow) {
    const { megaNavSubSelection } = this.state

    const { setParentState, onMenuClick } = this.props

    return (
      <MegaNavSection
        links={links}
        megaNavSubSelection={megaNavSubSelection}
        setParentState={setParentState}
        onMenuClick={onMenuClick}
        tabIndex={!shouldShow ? -1 : 0}
        ariaHidden={!shouldShow}
      />
    )
  }

  renderDetails(data) {
    const shouldShow =
      get(data, `firstLevelNavigationText`, ``) ===
      this.state.megaNavSubviewSelection

    const activeHeaderOption = find(
      this.props.navigationDetails,
      (item) =>
        get(item, `firstLevelNavigationText`, ``) ===
        this.state.megaNavSubviewSelection,
    ) || { secondLevelSections: [] }

    return (
      <div
        className="ml-5 mr-4 d-md-flex"
        style={{
          height: shouldShow ? `auto` : 0,
          marginTop: shouldShow ? `1.5rem` : 0,
          overflow: `hidden`,
          transition: `0.3s all`,
        }}
        aria-hidden={!shouldShow}
      >
        {map(activeHeaderOption.secondLevelSections, (section) => (
          <div className="column">
            <Typography
              component="h4"
              className="column-title maax-font-weight-bold wm-link-light-green"
            >
              {get(section, `secondLevelHeading`, ``)}
            </Typography>
            {this.renderMegaNavSection(section.secondLevelItems, shouldShow)}
            {section.ctaText ? (
              <ButtonArrow
                aria-hidden={!shouldShow}
                tabIndex={!shouldShow ? -1 : 0}
                isExternalLink={section.isExternalLink}
                href={get(section, `ctaLink`, ``)}
                target="_blank"
                rel="noopener noreferrer"
                key="1"
                className="maax-font-weight-bold quick-items pb-2"
                onClick={() => {
                  this.props.onMenuClick(false)
                }}
              >
                {get(section, `ctaText`, ``)}
              </ButtonArrow>
            ) : null}
          </div>
        ))}
      </div>
    )
  }

  renderLogIn() {
    const {
      isLoggedIn,
      onMenuClick,
      strings,
      utilityBarLinks,
      createProfileText,
      logOut,
      router,
    } = this.props

    const data =
      find(
        utilityBarLinks,
        (item) => get(item, `utilityType`, ``) === menuItems.MY_WM,
      ) || {}

    return (
      <div className="mt-5">
        <ButtonPrimary
          fullWidth
          className="Header__mobile-login-button maax-font-weight-bold  w-100 "
          analytics_key={get(data, `analytics_key`, ``)}
          onClick={() => {
            const redirectURL = isLoggedIn
              ? feUrls.MYWM_DASHBOARD
              : feUrls.LOGIN

            // eslint-disable-next-line no-useless-escape
            const urlWithoutDomain = redirectURL.replace(/^.*\/\/[^\/]+/, "")

            // /* teamsite pages should handle routing externally */
            if (isTeamsitePage(ssrWindow.location.pathname) || !isMyWMApp) {
              ssrWindow.location = redirectURL
            } else {
              /* pages that fall within mywm should handle routing internally */
              router.push(urlWithoutDomain)
            }
            onMenuClick()
          }}
        >
          <ReactSVG
            wrapper="span"
            className="logout pr-2 d-flex align-items-center"
            src={getContentUrl(data.linkIcon)}
          />
          {isLoggedIn ? strings.MY_WM : strings.LOG_IN}
        </ButtonPrimary>
        {!isLoggedIn && (
          <div className="pt-3 mb-3">
            {/* <ButtonArrow>
            <Link
              className="pl-1 has-focus"
              href={feUrls.USER_REGISTER}
              isExternalLink
            >
              {strings.CREATE_YOUR_ONLINE_PROFILE}
            </Link>
          </ButtonArrow> */}

            <ButtonPrimary
              analytics_key={get(data, `analytics_key`, ``)}
              className="Header__mobile-login-button maax-font-weight-bold  w-100 "
              invertColor
              onClick={() => {
                ssrWindow.location = feUrls.USER_REGISTER
              }}
            >
              {createProfileText}
            </ButtonPrimary>
          </div>
        )}
        {isLoggedIn && (
          <div className="d-md-flex align-items-center mb-4">
            <div className="mr-4 mt-4 mr-md-0 w-100">
              <ButtonPrimary
                className="TopMenuItem__logout-button maax-font-weight-bold w-100"
                onClick={() => {
                  logOut()
                }}
                invertColor
              >
                {strings.LOG_OUT}
              </ButtonPrimary>
            </div>
          </div>
        )}
      </div>
    )
  }

  renderButtons() {
    const {
      isLoggedIn,
      isSingleAccount,
      language,
      utilityBarLinks,
      userDetails,
      logOut,
      strings,
      hasFrPage = true,
    } = this.props

    return (
      <>
        <div className="paybill-button d-flex align-items-center justify-content-start flex-wrap">
          <div className="lang-dropdown d-flex mr-4">
            {hasFrPage && languages.length > 0 ? (
              <LanguageDropdown languages={languages} />
            ) : null}
          </div>
          <div
            className="d-flex my-4"
            style={{
              width: `auto !important`,
            }}
          >
            {map(utilityBarLinks, (item, index) => {
              const utilityType = get(item, `utilityType`, ``)
              const utilityLink = get(item, `utilityLink`, ``)
              const utilityLabel = get(item, `utilityLabel`, ``)
              const analyticsKey = get(item, `analytics_key`, ``)

              if (
                utilityType === menuItems.MY_WM ||
                utilityType === menuItems.CART ||
                utilityType === menuItems.ALERTS
              ) {
                return null
              }

              return (
                <ButtonTextIcon
                  analytics_key={analyticsKey}
                  className="maax-font-weight-regular wm-link-light-green"
                  key={index}
                  onClick={() => {
                    if (utilityLink !== ``) {
                      let finalUrl = item.utilityLink
                      const languageRoute = getLanguageRoute(language)

                      if (utilityType === `paymybill`) {
                        if (isLoggedIn && isSingleAccount) {
                          finalUrl = `${languageRoute}/mywm/user/my-payment/billing/details`
                        } else if (isLoggedIn) {
                          finalUrl = `${languageRoute}/mywm/user/my-payment/billing/overview`
                        } else {
                          finalUrl = `${languageRoute}/mywm/my-payment/verify?redirect=${languageRoute}/mywm/user/my-payment/billing`
                        }
                      }

                      ssrWindow.location = finalUrl
                    }
                  }}
                  style={{
                    marginRight: 10,
                  }}
                >
                  {isLoggedIn && utilityType === menuItems.MY_WM
                    ? `${this.props.strings.HELLO} ${userDetails.firstName}`
                    : utilityLabel === `Cart`
                    ? ``
                    : utilityLabel}
                </ButtonTextIcon>
              )
            })}
          </div>
        </div>
        {isLoggedIn && (
          <>
            <div
              className="d-none d-md-flex align-items-center flex-grow-1 justify-content-between mb-4 maax-font-weight-regular"
              style={{ fontSize: `1rem` }}
            >
              <div className="d-flex align-items-center">
                <div className="mr-1">{strings.HAVE_A_BILLING_ACCOUNT}</div>
                <Link href={feUrls.MYWM_MANAGE_ACCOUNTS} isExternalLink>
                  {strings.LINK_ACCOUNT}
                </Link>
              </div>
            </div>
          </>
        )}
        {isLoggedIn && (
          <div className="d-none d-md-flex align-items-center flex-grow-1 justify-content-between mb-4 maax-font-weight-bold">
            <div className="mr-4 mr-md-0">
              <Link
                onClick={() => {
                  logOut()
                }}
              >
                {strings.LOG_OUT}
              </Link>
            </div>
          </div>
        )}
      </>
    )
  }

  renderSearch() {
    return (
      <div
        className="d-flex justify-content-center"
        style={{ position: `relative` }}
      >
        <div
          className="MegaNav__search"
          style={{
            left: `0.5rem`,
            position: `absolute`,
            top: `1rem`,
          }}
        >
          <span onClick={this.navigateToZendesk}>
            <ReactSVG
              wrapper="span"
              src={getContentUrl("/content/dam/wm/icons/green-search-icon.svg")}
              className="react-svg"
            />
          </span>
        </div>
        <form
          className="w-100"
          onSubmit={(e) => {
            e.preventDefault()
            this.navigateToZendesk()
          }}
        >
          <TextInput
            className={`py-1 w-100 ${this.props.language}`}
            name="search"
            label={this.props.strings.SEARCH_ZENDESK}
            inputStyle={{
              paddingLeft: `2rem`,
            }}
            onChange={(value) => {
              this.setState({
                searchText: value,
              })
            }}
            value={this.state.searchText}
          />
        </form>
      </div>
    )
  }

  render() {
    const { megaNavSubviewSelection, showUserScreen } = this.state

    const {
      navigationDetails,
      closeMegaNav,
      onMenuClick,
      copyright,
      hasFrPage = true,
      legalLinks,
      pageLocales,
      siteLanguage,
      strings,
      isLoggedIn,
      logOut,
      searchPlaceholder,
      setIsSearchOpen,
    } = this.props

    const pageLanguages = filter(
      languages,
      (language) =>
        !isEmpty(pageLocales) && pageLocales.indexOf(language.code) !== -1,
    )

    const handleKeyDown = (e) => {
      if (e.keyCode === KEY_CODE_MAPPING.TAB && e.shiftKey) {
        e.preventDefault()
        ssrWindow.document.querySelector(`[aria-label="Close menu"]`)?.focus()
      }
    }

    return (
      <div
        className="MobileNavItems subMenuItems d-flex flex-column"
        data-testid="MobileNavItems"
      >
        <div
          className="container"
          style={{
            padding: `0 20px`,
          }}
        >
          <Button
            ariaLabel="Search"
            tabIndex="0"
            overrideClass="MobileNavItems__search-icon py-1 px-2 my-2 d-flex align-items-center w-100 wm-border-gray link"
            fontClass="maax-font-weight-regular"
            style={{
              background: `$Sand`,
              borderRadius: 4,
              color: `#767676`,
              fontSize: `0.825rem`,
              textIndent: `0.625rem`,
            }}
            onClick={() => {
              setIsSearchOpen(true)
            }}
            onKeyDown={(e) => {
              handleKeyDown(e)
            }}
          >
            <ReactSVG
              wrapper="span"
              src={getContentUrl("/content/dam/wm/icons/search-icon.svg")}
              className="react-svg"
            />
            <div>{searchPlaceholder}</div>
          </Button>
          <div
            className="nav-links overflow-auto"
            style={{ position: `relative` }}
          >
            {/* Menu items */}
            {!showUserScreen
              ? navigationDetails.map((menuItem, index) => (
                  <div key={index}>
                    <MenuItem
                      {...menuItem}
                      closeMegaNav={closeMegaNav}
                      onMegaNavSelection={onMenuClick}
                      onMegaNavSubviewSelection={(megaNavSubviewSelection) => {
                        this.setState({
                          megaNavSubviewSelection:
                            // eslint-disable-next-line react/no-access-state-in-setstate
                            this.state.megaNavSubviewSelection ===
                            menuItem.firstLevelNavigationText
                              ? null
                              : megaNavSubviewSelection,
                        })
                      }}
                      megaNavSelection={megaNavSubviewSelection}
                    />
                    {this.renderDetails(menuItem)}
                  </div>
                ))
              : ``}
          </div>
          {this.renderLogIn()}
          {this.renderButtons()}
          {isLoggedIn && (
            <div className="d-md-none">
              <div className="mb-4 d-flex align-items-center">
                <div className="mr-1">{strings.HAVE_A_BILLING_ACCOUNT}</div>
                <Link href={feUrls.MYWM_MANAGE_ACCOUNTS} isExternalLink>
                  {strings.LINK_ACCOUNT}
                </Link>
              </div>
              <div className="mb-4 maax-font-weight-bold">
                <Link
                  className="TopMenuItem__logout-button"
                  onClick={() => {
                    logOut()
                  }}
                >
                  {strings.LOG_OUT}
                </Link>
              </div>
            </div>
          )}
        </div>
        <FooterLegal
          copyright={copyright}
          hasFrPage={hasFrPage}
          languages={
            !isEmpty(pageLocales) && pageLocales.length > 0
              ? pageLanguages
              : languages
          }
          legalLinks={legalLinks}
          siteLanguage={siteLanguage}
          isMobileNav
        />
      </div>
    )
  }
}

MobileNavItems.propTypes = {
  createProfileText: PropTypes.string,
  onMenuClick: PropTypes.func.isRequired,
  navigationDetails: PropTypes.array.isRequired,
  firstLevelNavigationText: PropTypes.array.isRequired,
  closeMegaNav: PropTypes.func.isRequired,
  copyright: PropTypes.string.isRequired,
  hasFrPage: PropTypes.bool.isRequired,
  legalLinks: PropTypes.array.isRequired,
  pageLocales: PropTypes.array.isRequired,
  siteLanguage: PropTypes.object.isRequired,
  isSingleAccount: PropTypes.bool.isRequired,
  logo: PropTypes.string.isRequired,
  logoLink: PropTypes.string,
  utilityBarLinks: PropTypes.array.isRequired,
  userDetails: PropTypes.object.isRequired,
  setParentState: PropTypes.func.isRequired,
  /* From withAuthentication */
  isLoggedIn: PropTypes.bool.isRequired,
  logOut: PropTypes.func.isRequired,
  /* From withLocalization */
  strings: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  router: PropTypes.object.isRequired,
  searchPlaceholder: PropTypes.node,
  setIsSearchOpen: PropTypes.func.isRequired,
}

MobileNavItems.defaultProps = {
  logoLink: ``,
  createProfileText: ``,
  searchPlaceholder: null,
}

export default withLocalization(strings)(
  withAuthentication(withRouter(MobileNavItems)),
)
